o2-tab-content {
  display: none;
}

o2-tab-content[selected] {
  display: block;
}

.o2-tab-content {
}
